
import { store } from '@/store'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Message',
  props: {
    title: String,
    content: String
  },
  setup(props, { emit }) {
    function ok() {
      store.modal.hideModal('Message')
    }
    return { ok }
  }
})
